/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React from 'react';
import cx from 'classnames';
import { useUserProfile } from '@broadleaf/admin-components/dist/authentication';
import { Anchor } from '@broadleaf/admin-components/dist/common/helpers/Portal';
import SettingsDropdown from '@broadleaf/admin-components/dist/view/components/Header/SettingsDropdown';
import UserSettingsDropdown from '@broadleaf/admin-components/dist/view/components/Header/UserSettingsDropdown';
import { HeaderProps } from '@broadleaf/admin-components/dist/view/components/Header';
import HelpButton from './HelpButton';

export const AuroraHeader: React.FC<HeaderProps> = ({
  className,
  onLogoutClick,
  onChangePasswordClick
}) => {
  const user = useUserProfile();

  return (
    <div className="tw-flex tw-w-full tw-flex-col">
      <Anchor component="div" id="read-only-banner-target" />

      <div
        className={cx(
          className,
          'tw-relative tw-flex tw-max-w-full tw-items-center tw-border-b tw-border-gray-800 tw-bg-gray-800 tw-px-3 tw-py-2 tw-shadow'
        )}
      >
        <div className="tw-ml-auto" />

        <div className="tw-flex tw-items-center tw-space-x-6 rtl:tw-space-x-reverse">
          <div className="tw-flex tw-items-center tw-space-x-2 rtl:tw-space-x-reverse">
            <Anchor component="span" id="metadata-view-filter" />
          </div>
          <div className="tw-flex tw-items-center tw-space-x-2 rtl:tw-space-x-reverse">
            <HelpButton />
            <SettingsDropdown />
            <UserSettingsDropdown
              onChangePasswordClick={onChangePasswordClick}
              onLogoutClick={onLogoutClick}
              user={user}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuroraHeader;
